module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/icon_shop-6f7d4f085c93760b77dcce8f62c4e9f5.png";